<template>
  <div class="stats">
    <h1>Historique</h1>
    <div class="graph-container">
      <md-button class="md-dense md-raised md-primary" @click="goBack"
        >Retour</md-button
      >
      Graph
      {{ rinkId }}
      <chart :chartdata="chartData" v-if="chartReady"></chart>
    </div>
  </div>
</template>

<style scoped>
.stats {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: -webkit-fill-available;
  background: rgba(0, 0, 0, 0.5);
  padding: 50px 100px;
}

h1 {
  font-size: 6em;
  line-height: 1em;
  margin: 0;
  color: #fff;
}

.graph-container {
  flex: 1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  padding: 20px;
}
</style>

<script>
import firebase from "firebase/app";
import Chart from "../components/Chart";
import { EventBus } from "../main";

export default {
  name: "stats",
  components: {
    Chart
  },
  data: () => ({
    rink: null,
    chartReady: false,
    chartData: {
      labels: [],
      datasets: [
        {
          label: "Data One",
          backgroundColor: "#f87979",
          data: []
        }
      ]
    }
  }),
  computed: {
    rinkId: function() {
      return this.$route.query.patinoire || null;
    }
  },
  mounted() {
    if (EventBus.initialized) {
      this.setInitialized;
    } else {
      EventBus.$on("initialized", this.setInitialized);
    }
  },
  beforeDestroy() {
    EventBus.$off("initialized");
  },
  methods: {
    async setInitialized() {
      let rink = EventBus.getRink(this.rinkId);

      if (rink && rink.name) {
        let snapshot = await firebase
          .database()
          .ref("/history")
          .child(rink.name)
          .orderByKey()
          .startAt("2018-10-01")
          .once("value");
        let history = snapshot.val();
        // console.log(history);

        for (let date in history) {
          let value = history[date][0];
          this.chartData.labels.push(date);
          this.chartData.datasets[0].data.push(value);
        }

        this.chartReady = true;
      }
    },
    goBack() {
      this.$router.push("/");
    }
  }
};
</script>
